import { createSvgIcon } from "@mui/material/utils";

/**
 * Search icon.
 *
 * ![SearchIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi4xNiAtMi4xNiAyMi4zMiAyMi4zMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik0xNi41IDE2LjVMMTMuNTgzNCAxMy41ODMzTTE1LjY2NjcgOC41ODMzM0MxNS42NjY3IDEyLjQ5NTQgMTIuNDk1NCAxNS42NjY3IDguNTgzMzMgMTUuNjY2N0M0LjY3MTMyIDE1LjY2NjcgMS41IDEyLjQ5NTQgMS41IDguNTgzMzNDMS41IDQuNjcxMzIgNC42NzEzMiAxLjUgOC41ODMzMyAxLjVDMTIuNDk1NCAxLjUgMTUuNjY2NyA0LjY3MTMyIDE1LjY2NjcgOC41ODMzM1oiIHN0cm9rZT0iIzEwMTgyOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPjwvc3ZnPg==)
 */
const SearchIcon = createSvgIcon(
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 16.5L13.5834 13.5833M15.6667 8.58333C15.6667 12.4954 12.4954 15.6667 8.58333 15.6667C4.67132 15.6667 1.5 12.4954 1.5 8.58333C1.5 4.67132 4.67132 1.5 8.58333 1.5C12.4954 1.5 15.6667 4.67132 15.6667 8.58333Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Search"
);

export default SearchIcon;
